export enum FlightTimeType {
  ARRIVAL_BASED = "ARRIVAL_BASED",
  DEPARTURE_BASED = "DEPARTURE_BASED",
}
